export default {
  YAPIURL: 'https://yapi.bladex.cn/mock/74294',
  VERSION: '2.0.5',
  ORDER: {
    url: 'https://payment.javablade.com/record',
    //url: 'http://localhost:8800/record',
  },
  PAY: {
    //开发模式
    //url:'http://blade.natapp1.cc/wx/scan',
    //生产模式
    url: 'https://payment.javablade.com/wx/scan',
  },
  MARKET: {
    //开发模式
    //url:'http://blade.natapp1.cc/wx/scan',
    //生产模式
    url: 'https://payment.javablade.com/mk/scan',
  },
  GIT: {
    url: 'https://payment.javablade.com/api/register?tenant=bladex',
    loginurl: 'https://payment.javablade.com/api/login/',
    avueUrl: 'https://api.avuejs.com/send/user?version=avue-data-java',
    avueDataUrl: 'https://api.avuejs.com/send/user?version=avue-data-java',
    avueAIUrl: 'https://api.avuejs.com/send/user?version=avue-ai-java',
    avueIotUrl: 'https://api.avuejs.com/send/user?version=avue-iot-java',
    avueKey: '0901D35BFEBD2795DC15EBAADA146580',
    //url: 'http://localhost:8800/api/register?tenant=bladex',
    //loginurl: 'http://localhost:8800/api/login/'
  },
  //固定账号密码
  LOGIN: {
    ACCOUNT: 'chill',
    PWD: 'Demonchill.',
  },
  //七牛oss配置
  QINIU: {
    AK: '',
    SK: '',
    scope: 'test',
    url: 'https://cdn.avue.top/'
  },
  //阿里oss配置
  ALI: {
    region: 'oss-cn-beijing',
    endpoint: 'oss-cn-beijing.aliyuncs.com',
    accessKeyId: '',
    accessKeySecret: '',
    bucket: 'avue',
  }
}
